import { Component, Input, OnInit } from '@angular/core';
import { AccountSettingsService } from '../../account-settings.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../shared/dialog/confirm-dialog/confirm-dialog.component';
import { NotificationService } from '../../../shared/notification.service';
import { Ng1IpInfoService } from '../../../shared/ng1/ng1-ip-info.service';
import { AdminMsisdn, Msisdn } from '../../../shared/msisdn/msisdns';
import { Subscription } from '../../../shared/models/plans';
import { Ng1ModalService } from '../../../shared/ng1/ng1-modal.service';
import { isFreePlan } from '../../../shared/utils/subscriptionUtils';

@Component({
  selector: 'cc-phone-numbers-plan',
  templateUrl: './phone-numbers-plan.component.html',
  styleUrls: ['./phone-numbers-plan.component.scss']
})
export class PhoneNumbersPlanComponent implements OnInit {
  @Input() subscription: Subscription;
  public msisdnsSubscriptions: AdminMsisdn[];
  public msisdns: Msisdn[];
  public isFreePlan = isFreePlan;

  constructor(
    private accountSettingsService: AccountSettingsService,
    private router: Router,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private ng1IpInfoService: Ng1IpInfoService,
    private ng1ModalService: Ng1ModalService
  ) {}

  ngOnInit() {
    this.accountSettingsService.getMsisdnsSubscriptions().subscribe(msisdns => (this.msisdnsSubscriptions = msisdns));
    this.accountSettingsService.getMsisdns().subscribe(msisdns => (this.msisdns = msisdns));
  }

  buyNewNumber() {
    if (isFreePlan(this.subscription.licenses[0].planName)) {
      this.showUpgradeAccountModal();
      return;
    } else {
      const code = this.ng1IpInfoService.getCountry();
      this.router.navigateByUrl(`/get-new-number/pricing/${code}`);
    }
  }

  showUpgradeAccountModal() {
    return this.ng1ModalService.lazyModalService
      .showModal(
        {
          title: 'TRIAL_MODAL.TITLE',
          body: 'TRIAL_MODAL.PHONE_NUMBER_TEXT',
          confirm: 'TRIAL_MODAL.CONFIRM'
        },
        true
      )
      .then(() => {
        this.router.navigateByUrl('/choose-plan');
      });
  }

  getClientMsisdn(msisdnSubscription: AdminMsisdn): Msisdn | undefined {
    return this.msisdns.find(number => number.label === msisdnSubscription.label);
  }

  cancelNumberSubscription(msisdn: AdminMsisdn) {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'PLANS.CANCEL_PHONE_NUMBER.MODAL.TITLE',
          body: 'PLANS.CANCEL_PHONE_NUMBER.MODAL.DESCRIPTION',
          confirm: 'PLANS.CANCEL_PHONE_NUMBER.MODAL.CONFIRM'
        }
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.tryToDetachMsisdn(msisdn);
        }
      });
  }

  private tryToDetachMsisdn(msisdn: AdminMsisdn) {
    const chosenMsisdn = this.getClientMsisdn(msisdn);
    this.accountSettingsService.isDetachableNumber(chosenMsisdn.id).subscribe(
      result => {
        if (result && result.detachable) {
          this.doDetachMsisdn(chosenMsisdn);
        } else {
          this.notificationService.open('PLANS.NUMBER_CANNOT_BE_REMOVED');
        }
      },
      error => {
        this.notificationService.open('ERROR');
      }
    );
  }

  private doDetachMsisdn(chosenMsisdn: Msisdn) {
    this.accountSettingsService.detachNumber(chosenMsisdn.id).subscribe(
      () => {
        this.msisdnsSubscriptions = this.msisdnsSubscriptions.filter(msisdn => msisdn.label !== chosenMsisdn.label);
        this.notificationService.open('SUCCESS_MSG');
      },
      error => {
        this.notificationService.open('ERROR');
      }
    );
  }

  isFree(msisdn: AdminMsisdn) {
    return ['INITIAL', 'FREE_CHOSEN'].includes(msisdn.acquisitionType);
  }
}
